function getOperationName(document) {
  for (const definition of document.definitions) {
    if (definition.kind === "OperationDefinition" && definition.name?.value) {
      return definition.name.value;
    }
  }
  return "";
}
export {
  getOperationName
};
